import { createContext, useContext } from 'react';

export const UserContext = createContext(null);

export function useUserContext() {
    const ctx = useContext(UserContext);
    if (!ctx) throw new Error('useUserContext muss innerhalb von UserProvider genutzt werden');
    return ctx;
}